import axios from 'axios'

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL + '/admin';

const axiosPermissionInstance = axios.create({
    baseURL: API_BASE_URL,
});

axiosPermissionInstance.interceptors.request.use(config => {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const createAdminUser = async (axios, requestBody) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/create`, requestBody);

        if (response.data.code === 200) {
            return response.data;
        } else {
            throw new Error(response.data.message || 'Create Admin User Failed');
        }
    } catch (error) {
        console.error('Error Create Admin User:', error);
        throw error;
    }
};

export const getAdminUserWithPagination = async (axios, requestBody) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/paginate`, requestBody);

        if (response.data.code === 200) {
            return response.data;
        } else {
            throw new Error(response.data.message || 'Admin User Pagination Failed');
        }
    } catch (error) {
        console.error('Error Admin User:', error);
        throw error;
    }
};

export const getAdminUserWithId = async (axios, id) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/${id}`);

        if (response.data.code === 200) {
            return response.data;
        } else {
            throw new Error(response.data.message || 'Admin User Data Failed');
        }
    } catch (error) {
        console.error('Error Admin User:', error);
        throw error;
    }
};

export const editAdminUser = async (axios, requestBody) => {
    try {
        const response = await axios.patch(`${API_BASE_URL}/update`, requestBody);

        if (response.data.code === 200) {
            return response.data;
        } else {
            throw new Error(response.data.message || 'Edit Admin User Failed');
        }
    } catch (error) {
        console.error('Edit Admin User:', error);
        throw error;
    }
};

export const updateActiveAdminUser = async (axios, id) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/update_active/${id}`);

        if (response.data.code === 200) {
            return response.data;
        } else {
            throw new Error(response.data.message || 'Edit Admin User Failed');
        }
    } catch (error) {
        console.error('Edit Admin User:', error);
        throw error;
    }
};

export const updatePassword = async (axios, requestBody) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/update_password`, requestBody);

        if (response.data.code === 200) {
            return response.data;
        } else {
            throw new Error(response.data.message || 'updatePassword Failed');
        }
    } catch (error) {
        console.error('updatePassword:', error);
        throw error;
    }
};

export const getAdminUserList = async (axios) => {
    try {
        const response = await axios.get(`${API_BASE_URL}`);

        if (response.data.code === 200) {
            return response.data;
        } else {
            throw new Error(response.data.message || 'Admin User Data Failed');
        }
    } catch (error) {
        console.error('Error Admin User:', error);
        throw error;
    }
};

export const getRoleList = async (axios) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/roles`);

        if (response.data.code === 200) {
            return response.data;
        } else {
            throw new Error(response.data.message || 'Role Data Failed');
        }
    } catch (error) {
        console.error('Error Role User:', error);
        throw error;
    }
};

export const getAdminUserPermission = async (id) => {
    try {
        const response = await axiosPermissionInstance.get(`/${id}/permissions`);

        if (response.data.code === 200) {
            return response.data;
        } else {
            throw new Error(response.data.message || 'Admin User Permission Failed');
        }
    } catch (error) {
        console.error('Error Admin User:', error);
        throw error;
    }
};

export const updatePermission = async (axios, uid, requestBody) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/update_permission/${uid}`, requestBody);

        if (response.data.code === 200) {
            return response.data;
        } else {
            throw new Error(response.data.message || 'update permission Failed');
        }
    } catch (error) {
        console.error('update permission:', error);
        throw error;
    }
};

export const getRolePermission = async (id) => {
    try {
        const response = await axiosPermissionInstance.get(`/roles/${id}/permissions`);

        if (response.data.code === 200) {
            return response.data;
        } else {
            throw new Error(response.data.message || 'Admin User Permission Failed');
        }
    } catch (error) {
        console.error('Error Admin User:', error);
        throw error;
    }
};

export const getPermissionList = async (axios) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/permissions`);

        if (response.data.code === 200) {
            return response.data;
        } else {
            throw new Error(response.data.message || 'Permission Data Failed');
        }
    } catch (error) {
        console.error('Error Permission:', error);
        throw error;
    }
};

export const checkAdminUserWithId = async (id) => {
    try {
        const response = await axiosPermissionInstance.get(`${API_BASE_URL}/${id}`);

        if (response.data.code === 200) {
            return response.data;
        } else {
            throw new Error(response.data.message || 'Admin User Data Failed');
        }
    } catch (error) {
        console.error('Error Admin User:', error);
        throw error;
    }
};